import React, { forwardRef } from "react";
import { formatRupiah } from "../../../../../helper/formatNumber";
import { formatDateTransactionDetail } from "../../../../../helper/formatDate";

const SalesReceipt = forwardRef(({ transactionData }, ref) => {
  return (
    <div className="receipt" ref={ref}>
      <div className="header">
        <h2>Apotek & Klinik TUNAS</h2>
        <div style={{ height: "8px" }} />
        <p>Jl. Boulevar Hijau Raya, B1 45-46</p>
        <p>Harapan Indah, Bekasi</p>
        <p>Telp: (021)88976656 / 0851-0060-4355</p>
      </div>

      <div className="transaction">
        <p>
          No Transaksi:{" "}
          {transactionData?.product_transaction_invoice_number || "N/A"}
        </p>
        <p>
          Tanggal Transaksi:{" "}
          {formatDateTransactionDetail(
            transactionData?.product_transaction_date
          ) || ""}
        </p>
        {transactionData?.doctor_name !== "" && (
          <p>Dokter: {transactionData?.doctor_name}</p>
        )}
        {transactionData?.patient_name !== "" && (
          <p>Pasien: {transactionData?.patient_name}</p>
        )}
      </div>

      <div className="separator"></div>

      <div className="items">
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>Deskripsi</th>
              <th>Harga@</th>
              <th>Qty</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {transactionData?.product_transaction_data?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.product_transaction_name}</td>
                <td>{formatRupiah(item.product_transaction_per_item_price)}</td>
                <td>{item.product_transaction_quantity}</td>
                <td>{formatRupiah(item.product_transaction_price)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="separator"></div>

      <div className="totals">
        {transactionData?.courier_fee != null &&
          transactionData?.courier_fee > 0 && (
            <p>Ongkos Kirim: {formatRupiah(transactionData?.courier_fee)}</p>
          )}
        <p>
          Total Harga: {formatRupiah(transactionData?.total_transaction || 0)}
        </p>
        {transactionData?.total_insurance_covered != null &&
          transactionData?.total_insurance_covered > 0 && (
            <p>
              Ditanggung Asuransi: -
              {formatRupiah(transactionData?.total_insurance_covered)}
            </p>
          )}
        {transactionData?.total_insurance_covered > 0 ? (
          <p>
            <b>
              Uang Bayar{" "}
              {transactionData.payment_method === "TIDAK ADA"
                ? ""
                : `(${transactionData.payment_method})`}
            </b>
            : <b>{formatRupiah(transactionData?.total_payment)}</b>
          </p>
        ) : (
          <p>
            <b>Uang Bayar ({transactionData?.payment_method || "CASH"})</b>:{" "}
            <b>
              {formatRupiah(
                transactionData?.payment_method === "CASH"
                  ? transactionData?.cash_transaction
                  : transactionData?.total_transaction
              )}
            </b>
          </p>
        )}
        {transactionData?.cash_transaction != null &&
          transactionData?.cash_transaction !== 0 && (
            <p>
              Uang Kembali:{" "}
              {formatRupiah(
                transactionData?.cash_transaction -
                  transactionData?.total_transaction
              )}
            </p>
          )}
      </div>

      <div className="separator"></div>

      <div className="footer">
        <p>Kasir: {transactionData?.staff_name || "Unknown"}</p>
        <p>Barang yang sudah dibeli tidak dapat dikembalikan/ditukar</p>
        <p>----TERIMA KASIH----</p>
        <p>***SEMOGA LEKAS SEMBUH***</p>
      </div>
    </div>
  );
});

export default SalesReceipt;
